import { ProjectNameTranslation } from "@/types";

const getProjectTranslation = (
  nameTranslations: ProjectNameTranslation[] | undefined,
  locale: string,
): string | undefined => {
  if (!nameTranslations || nameTranslations.length === 0) return undefined;
  const match = nameTranslations.find((t) => t.language === locale);
  return match?.value || undefined;
};

export default getProjectTranslation;
